export const CustomerCompleteLedgerColumns = [
  {
    id: "invoice",
    title: "Invoice",
  },
  {
    id: "date",
    title: "Date",
  },
  {
    id: "desc",
    title: "Desc",
  },
  {
    id: "name",
    title: "Name",
    type: "Ledger",
  },
  {
    id: "qty",
    title: "QTY",
  },
  {
    id: "price",
    title: "U Price",
  },
  {
    id: "discount",
    title: "Discount",
  },
  {
    id: "cr",
    title: "CR",
  },
  {
    id: "dr",
    title: "DR",
  },
  {
    id: "balance",
    title: "Balance",
  },
];
